module.exports = __webpack_public_path__ + "static/media/nedia.6fdb4d47.png";